import React from 'react';
import moment from 'moment';

class TourDates extends React.Component {

  render() {
    const start = moment(this.props.start);
    if (!start.isValid()) {
      return (
        <span>
              -
        </span>);
    }
    return (
      <span>
        {moment(this.props.start).format('MM-DD') } - { moment(this.props.end).format('MM-DD-YYYY')}
      </span>

    );
  }
}
export default TourDates;



// WEBPACK FOOTER //
// src/routes/tours/components/TourDates.js